module.exports = __webpack_public_path__ + "img/2_16.b8ddcb74.png";